import axios from "./axios";

export default {
  async sendSMS(
    url,
    message,
    schedule,
    dateTime,
    numbers,
    radioBtnChoice = 1,
    selectedPredefinedSMS = null
  ) {
    const messages = await axios.postDataWithToken(
      url,
      {
        message,
        schedule,
        dateTime,
        numbers,
        radioBtnChoice,
        selectedPredefinedSMS,
      },
      localStorage.getItem("token")
    );
    return messages;
  },
  async getSMSCredits(url) {
    const smsCredits = await axios.getData(url, localStorage.getItem("token"));
    return smsCredits;
  },
  async getAllPredefinedSMSes(url) {
    const predefinedSMSes = await axios.getData(
      url,
      localStorage.getItem("token")
    );
    return predefinedSMSes;
  },
  async getSMSAnalytics(url) {
    const SMSAnalytics = await axios.getData(
      url,
      localStorage.getItem("token")
    );
    return SMSAnalytics;
  },
};
